export default __webpack_public_path__ + "static/media/790886725987205133.5406ae7a.png";